var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('VueSlickCarousel',{attrs:{"arrows":_vm.showArrows,"dots":true,"infinite":false}},_vm._l((_vm.postContent),function(media,index){return _c('div',{key:index,staticClass:"carousel-item"},[_c('Simple',{attrs:{"postData":_vm.postData,"postContent":media,"model":_vm.model,"VideoElementHandler":_vm.VideoElementHandler}})],1)}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }